import { APP_CONTEXT } from "shared/constants/index";

export const getWebAppType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (userAgent.match(/nykaa-android/i)) {
        try {
            return APP_CONTEXT.ANDROID;
        } catch (error) {
            //log exception
        }
    } else if (userAgent.match(/nykaa-ios/i)) {
        return APP_CONTEXT.IOS;
    } else {
        APP_CONTEXT.WEB;
    }
};
